import { render, staticRenderFns } from "./LandscapeWarning.vue?vue&type=template&id=b6a0f7cc&scoped=true&lang=pug&"
import script from "./LandscapeWarning.vue?vue&type=script&lang=js&"
export * from "./LandscapeWarning.vue?vue&type=script&lang=js&"
import style0 from "./LandscapeWarning.vue?vue&type=style&index=0&id=b6a0f7cc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a0f7cc",
  null
  
)

export default component.exports